var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { lock: true },
        },
      ],
      staticClass: "main_center",
      style: _vm.mainContentViewHeight,
    },
    [
      _c(
        "div",
        {
          staticClass: "top-content busWinessLeft",
          staticStyle: { "z-index": "3" },
        },
        [
          _c(
            "div",
            { staticClass: "left-navbar" },
            [
              _c("el-button", { on: { click: _vm.backRouter } }, [
                _vm._v("返回"),
              ]),
              !(_vm.ruleForm.endStatus == 1 || _vm.ruleForm.endStatus == 3) &&
              _vm.ruleForm.historyid == -1 &&
              _vm.hasBtnPermission("online_complaints_btn_agree")
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "debounce",
                          rawName: "v-debounce",
                          value: [_vm.isAgree, "click", 300, "argee"],
                          expression: "[isAgree, 'click', 300, 'argee']",
                        },
                      ],
                      attrs: { type: "primary" },
                    },
                    [_vm._v("同意")]
                  )
                : _vm._e(),
              _vm.hasBtnPermission("online_complaints_btn_agree") &&
              _vm.ruleForm.historyid == -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "debounce",
                          rawName: "v-debounce",
                          value: [_vm.isAgree, "click", 300, "noAgree"],
                          expression: "[isAgree, 'click', 300, 'noAgree']",
                        },
                      ],
                      staticClass: "noAgreeBtn",
                    },
                    [_vm._v("不同意")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "right-content busWinessRight" },
        [
          _c("div", { staticClass: "statusImg" }, [
            _vm.ruleForm.historyid == 0
              ? _c("img", {
                  attrs: {
                    src: require("../../../../../assets/images/agree.png"),
                  },
                })
              : _vm._e(),
            _vm.ruleForm.historyid == 1
              ? _c("img", {
                  attrs: {
                    src: require("../../../../../assets/images/noAgree.png"),
                  },
                })
              : _vm._e(),
            _vm.ruleForm.historyid == -1
              ? _c("img", {
                  attrs: {
                    src: require("../../../../../assets/images/waitHandle.png"),
                  },
                })
              : _vm._e(),
          ]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "220px" },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("投诉撤回申请")])]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "complaintCode", size: "small" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 投诉编号： "),
                                ]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.ruleForm.complaintCode) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "quashReason", size: "small" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 撤回原因： "),
                                ]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.ruleForm.quashReason) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "quashUser", size: "small" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 撤回申请人： "),
                                ]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.ruleForm.quashUser) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "linkPhone", size: "small" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 申请人联系方式： "),
                                ]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.ruleForm.linkPhone) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "申请人时间：",
                                prop: "createTime",
                                size: "small",
                              },
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.createTime))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    _vm._l(_vm.ruleForm.attachments, function (item, index) {
                      return _c(
                        "el-col",
                        {
                          key: index,
                          staticClass: "affixDown",
                          attrs: { span: 24 },
                        },
                        [
                          _c("affix-doc", {
                            attrs: {
                              isStar: true,
                              item: item,
                              name: item.fileTypeName,
                              labelWidth: "220px",
                            },
                            on: {
                              "update:item": function ($event) {
                                item = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("相关投诉信息")])]
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "投诉企业名称：",
                                  prop: "appelleeEntName",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleForm.appelleeEntName))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "投诉人：",
                                  prop: "complainter",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleForm.complainter))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "投诉标段名称：",
                                  prop: "bidSectionName",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleForm.bidSectionName))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "投诉标段编号：",
                                  prop: "bidSectionCode",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleForm.bidSectionCode))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "投诉提交时间：",
                                  prop: "complaintTime",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.ruleForm.complaintTime))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { size: "small" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "arrowRightBtn",
                                    on: { click: _vm.viewDetailInfo },
                                  },
                                  [
                                    _vm._v(" 查看详细投诉信息 "),
                                    _c("i", {
                                      staticClass: "el-icon-d-arrow-right",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("工作流")])]
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading.lock",
                            value: _vm.tableLoading,
                            expression: "tableLoading",
                            modifiers: { lock: true },
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.tableData, border: "", stripe: "" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            width: "50",
                            label: "序号",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taskName",
                            label: "任务名称",
                            width: "250",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "userName",
                            label: "执行人",
                            width: "300",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "excuteDate",
                            label: "执行时间",
                            width: "180",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "auditMsg", label: "意见" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "意见", visible: _vm.dialogVisible, width: "30%" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialogBox" },
            [
              _c("span", [_vm._v("处理意见：")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "100",
                  "show-word-limit": "",
                  rows: 4,
                },
                model: {
                  value: _vm.ruleForm.variables.opinion,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm.variables, "opinion", $$v)
                  },
                  expression: "ruleForm.variables.opinion",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSure },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "backBtn",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }